import { 
    baseTipoAnagraficaModel,
    baseGenereModel,
    baseTipoIdentificazioneModel,
    baseTipoDocumentoModel,
    basePaeseModel,
    baseProvinciaModel,
    baseComuneModel,
    baseTipoPartecipazioneModel,
    baseTipoRedditoModel,
    baseTipoPatrimonioModel,
    baseScopoPrestazioneModel,
    baseNaturaPrestazioneModel,
    baseOrigineFondiModel,
    baseMezzoPagamentoModel,
    baseRischioGradoModel
} from "../models";
import { query_base_app_setting, query_base_app_setting_all_by_key, query_base_rischio_grado_byTenantTipo } from "../query/baseTablesQueries";
import { insert_base_app_setting_global } from "../mutations/baseTablesMutations";
import { get_ateco_base } from "../query/anagraficaQueries"
import { mapBaseComuneRows } from "../helpers/comuneHelpers.mjs";
import { useQuery, useMutation } from "@1f/react-sdk"

export const BaseTableApi = () => { 
    const getAtecoBase = useQuery(
        get_ateco_base,
        {},
        { lazy: true, graphqlEndpoint: "aml:hasura:api://v1/graphql" }
    )
    const apiBaseAppSetting = useQuery(
        query_base_app_setting,
        {},
        { lazy: true, graphqlEndpoint: "aml:hasura:api://v1/graphql" }
    );
    const apiBaseAppSettingByKey = useQuery(
        query_base_app_setting_all_by_key,
        {},
        { lazy: true, graphqlEndpoint: "aml:hasura:api://v1/graphql" }
    );
    const apiInsertBaseAppSettingGlobal = useMutation(
        insert_base_app_setting_global,
        { graphqlEndpoint: "aml:hasura:api://v1/graphql" }
    );
    const apiBaseRischioGradoByTenantTipo = useQuery(
        query_base_rischio_grado_byTenantTipo,
        {},
        { lazy: true, graphqlEndpoint: "aml:hasura:api://v1/graphql" },
    );

    const GetBaseTipoAnagrafica = (baseAll) => {
        let arrTipoAnagItems = [];
        baseAll.data.data.base_tipo_anagrafica.map((item) =>
            arrTipoAnagItems.push(
                new baseTipoAnagraficaModel(
                    item.Id,
                    item.Key,
                    item.Value,
                    item.Order,
                    item.IsSystem
                )
            )
        );
        return arrTipoAnagItems;
    }
    const GetBaseGenere = (baseAll)=>{
        let arrGenereItems = [];
        baseAll.data.data.base_genere.map((item) =>
        arrGenereItems.push(
                new baseGenereModel(
                    item.Id,
                    item.Key,
                    item.Value,
                    item.Order,
                    item.IsSystem
                )
            )
        );
        return arrGenereItems;
    }
    const GetBaseTipoIdent = (baseAll) => {
        let arrtipoIdenItems = [];
        baseAll.data.data.base_tipo_identificazione.map((item) =>
        arrtipoIdenItems.push(
            new baseTipoIdentificazioneModel(
                item.Id,
                item.Key,
                item.Value,
                item.Order,
                item.IsSystem
            )
        ))
        return arrtipoIdenItems;
    }
    const GetBaseTipoDocumento = (baseAll) => {
        let arrTipoDocItems = [];
        baseAll.data.data.base_tipo_documento.map((item) =>
            arrTipoDocItems.push(
                new baseTipoDocumentoModel(
                    item.Id,
                    item.Key,
                    item.Value,
                    item.Order,
                    item.IsSystem,
                    item.PersonType,
                    item.DocumentTypeId,
                    item.ValidityMonths,
                    item.ValidityOffsetDays,
                    item.NextBirthDay
                )
            )
        );
        return arrTipoDocItems;
    }
    const GetBasePaese = (baseAll) => {
        let arrPaeseItems = [];
        baseAll.data.data.base_paese.map((item) =>
            arrPaeseItems.push(
                new basePaeseModel(
                    item.Id,
                    item.Nome,
                    item.Identificativo,
                    item.IsRischio
                )
            )
        );
        return arrPaeseItems;
    }
    const GetBaseProvincia = (baseAll) => {
        let arrProvinciaItems = [];
        baseAll.data.data.base_provincia.map((item) =>
            arrProvinciaItems.push(
                new baseProvinciaModel(
                    item.Id,
                    item.Nome,
                    item.Sigla,
                    item.Rischio
                )
            )
        );
        return arrProvinciaItems;
    }
    const GetBaseComune = (baseAll) => {
        const data = baseAll.data.data;
        const comuneRows = data.base_comune ?? [];
        const standardRows = data.base_stdcodes_comune;

        if (Array.isArray(standardRows)) {
            return mapBaseComuneRows(comuneRows, standardRows).map((item) =>
                new baseComuneModel(
                    item.id,
                    item.codiceIstatAttuale,
                    item.provincia,
                    item.nome,
                    item.codBelfiore,
                    item.codiceIstatStorico,
                    item.codiciIstatAttuali,
                    item.codiciIstatStorici,
                    item.codiciBelfiore,
                ),
            );
        }

        return comuneRows.map((item) =>
            new baseComuneModel(item.Id, item.Codice, item.Provincia, item.Nome, item.CodBelfiore),
        );
    }
    const GetBaseTipoPartecipazione = (baseAll) => {
        let arrTipoPartecipazioneItems = [];
        baseAll.data.data.base_tipo_partecipazione.map((item) =>
            arrTipoPartecipazioneItems.push(
                new baseTipoPartecipazioneModel(
                    item.Id,
                    item.Key,
                    item.Nome,
                    item.Descrizione,
                )
            )
        );
        return arrTipoPartecipazioneItems;
    }
    const GetBaseTipoRappresentanza = () => {
        return [
            { id: 0, name: "Mandato con rappresentanza" },
            { id: 1, name: "Mandato senza rappresentanza" },
            { id: 2, name: "Altro" },
        ];
    }
    const GetBasePoliticalRole = () => {
        return [
            "PRESIDENTE DELLA REPUBBLICA",
            "PRIMO MINISTRO",
            "MINISTRO",
            "VICE MINISTRO",
            "SOTTOSEGRETARIO",
            "PRESIDENTE DELLA REGIONE",
            "CONSIGLIERE REGIONALE",
            "PRESIDENTE DELLA PROVINCIA",
            "SINDACO",
            "DEPUTATO",
            "SENATORE",
            "PARLAMENTARE",
            "PARLAMENTARE EUROPEO",
            //Era un doppione di "CONSIGLIERE REGIONALE": nell'elenco Workspace questa
            //posizione è "Funzionario regionale" (enum REGIONAL_COUNCILLOR).
            "FUNZIONARIO REGIONALE",
            "UFFICIO DEGLI ESTERI",
        ]
    }
    const GetBaseTipoReddito = (baseAll) => {
        let arrTipoRedditoItems = [];
        baseAll.data.data.base_tipo_reddito.map((item) =>
            arrTipoRedditoItems.push(
                new baseTipoRedditoModel(
                    item.Id,
                    item.Key,
                    item.Value,
                    item.Order,
                    item.IsSystem
                )
            )
        );
        return arrTipoRedditoItems;
    }
    const GetBaseTipoPatrimonio = (baseAll) => {
        let arrTipoPartimonioItems = [];
        baseAll.data.data.base_tipo_patrimonio.map((item) =>
            arrTipoPartimonioItems.push(
                new baseTipoPatrimonioModel(
                    item.Id,
                    item.Key,
                    item.Value,
                    item.Order,
                    item.IsSystem
                )
            )
        );
        return arrTipoPartimonioItems;
    }
    const GetBaseScopoPrestazione = (baseAll) => {
        let arrScopoPrestazioneItems = [];
        baseAll.data.data.base_scopo_prestazione.map((item)=> 
            arrScopoPrestazioneItems.push(
                new baseScopoPrestazioneModel(
                    item.Id,
                    item.Key,
                    item.Value,
                    item.Order,
                    item.IsSystem
                )
            )
        )
        return arrScopoPrestazioneItems;
    }
    const GetBaseNaturaPrestazione = (baseAll) => {
        let arrBaseNaturaPrestItems = [];
        baseAll.data.data.base_natura_prestazione.map((item)=>
            arrBaseNaturaPrestItems.push(
                new baseNaturaPrestazioneModel(
                    item.Id,
                    item.Key,
                    item.Value,
                    item.Order,
                    item.IsSystem
                )
            )
        )
        return arrBaseNaturaPrestItems;
    }
    const GetBaseOrigineFondi = (baseAll) => {
        let arrBaseOrigineFondiItems = [];
        baseAll.data.data.base_origine_fondi.map((item)=>
            arrBaseOrigineFondiItems.push(
                new baseOrigineFondiModel(
                    item.Id,
                    item.Key,
                    item.Value,
                    item.Order,
                    item.IsSystem
                )
            )
        )
        return arrBaseOrigineFondiItems;
    }
    const GetBaseMezzoPagamento = (baseAll) => {
        let arrBaseMezzoPagItems = [];
        baseAll.data.data.base_mezzo_pagamento.map((item)=>
            arrBaseMezzoPagItems.push(
                new baseMezzoPagamentoModel(
                    item.Id,
                    item.Key,
                    item.Value,
                    item.Order,
                    item.IsSystem
                )
            )
        )
        return arrBaseMezzoPagItems;
    }
    const GetBaseAteco = async () => {
        try {
            let atecoResponse = await getAtecoBase.fetch();
            return atecoResponse.data.data.getAtecoBase;                         
        } catch (error) {
            throw new Error("Impossibile recuperare la base ateco: " + error.message);
        }
    }
    const GetBaseAppSetting = async (key) => {
        try {
            let appSettingsResponse = await apiBaseAppSetting.fetch({
                key: key,
            });
            if(appSettingsResponse && appSettingsResponse.data){
                return appSettingsResponse.data.data.base_app_setting[0].Value;
            }
        } catch (error) {
            throw new Error("Impossibile recuperare le impostazioni dell'app: " + error.message);
        }
    }
    // Risolve un app setting con il modello "default globale + override per tenant":
    // - se non esiste alcuna riga per il key -> crea il record globale (TenantId null) con il valore di default e lo ritorna;
    // - altrimenti usa l'override del tenant corrente se presente, in subordine il record globale (TenantId null).
    // Ritorna il Value (string) oppure null se non determinabile.
    const ResolveBaseAppSetting = async (key, tenantId, defaultValue = "true") => {
        try {
            let response = await apiBaseAppSettingByKey.fetch({ key: key });
            let rows = response?.data?.data?.base_app_setting ?? [];
            if (rows.length === 0) {
                // Nessun record: creiamo il default globale (TenantId null). Nessun insert scoped lato FE.
                await apiInsertBaseAppSettingGlobal.fetch({ key: key, value: defaultValue });
                return defaultValue;
            }
            let tenantOverride = rows.find((r) => r.TenantId === tenantId);
            if (tenantOverride) {
                return tenantOverride.Value;
            }
            let globalRow = rows.find((r) => r.TenantId === null || r.TenantId === undefined);
            if (globalRow) {
                return globalRow.Value;
            }
            // Esistono solo override di altri tenant e nessun globale: non determinabile.
            return null;
        } catch (error) {
            throw new Error("Impossibile risolvere l'impostazione dell'app '" + key + "': " + error.message);
        }
    }
    const GetBaseRischioGradoByTenantType = async (tenantType) => {
        try {
            let baseRischioGradoResponse = await apiBaseRischioGradoByTenantTipo.fetch({
                tenantTipoId: tenantType,
            });
            if(baseRischioGradoResponse && baseRischioGradoResponse.data){
                return baseRischioGradoResponse.data.data.base_rischio_grado.map((item) => new baseRischioGradoModel(
                    item.Id,
                    item.TipoRischio,
                    item.GradoRischio,
                    item.AdeguataVerifica,
                    item.ValoreRischioDa,
                    item.ValoreRischioA,
                    item.Colore,
                    item.Offset,
                ));
            }
        } catch (error) {
            throw new Error("Impossibile recuperare la base rischio grado: " + error.message);
        }
    }

    return {
        GetBaseTipoAnagrafica,
        GetBaseGenere,
        GetBaseTipoIdent,
        GetBaseTipoDocumento,
        GetBasePaese,
        GetBaseProvincia,
        GetBaseTipoPartecipazione,
        GetBaseTipoRappresentanza,
        GetBasePoliticalRole,
        GetBaseTipoReddito,
        GetBaseTipoPatrimonio,
        GetBaseComune,
        GetBaseScopoPrestazione,
        GetBaseNaturaPrestazione,
        GetBaseOrigineFondi,
        GetBaseMezzoPagamento,
        GetBaseAteco,
        GetBaseAppSetting,
        ResolveBaseAppSetting,
        GetBaseRischioGradoByTenantType
    }
}

export default BaseTableApi;